import React, { useRef, useState } from "react";
import styles from "./index.module.css";

import Button from "shared/Button";
import CopyBox from "shared/CopyBox";
import { ENVIRONMENT_CONFIG } from "shared/globals";

import { useGenerator, STATUS_GENERATING } from "./useGenerator";
import TabActionBar from "shared/TabActionBar";
import AlertNotice from "shared/AlertNotice";
import { IconAlert } from "@wwg/icons";

const cmsUrl = ENVIRONMENT_CONFIG.cmsUrl;
const cmsLoginUrl = new URL("/wp-login.php", cmsUrl).toString();

const cmsNewUrl = ENVIRONMENT_CONFIG.cmsNewUrl;
const cmsNewLoginUrl = cmsNewUrl
  ? new URL("/wp-login.php", cmsNewUrl).toString()
  : null;

const Generate = ({ iboNumber, activeOutput, setActiveOutput }) => {
  const iboEmail = `qalogin+${iboNumber}@wwdb.com`;

  const { generate, status, password, generateOtp, otp, otpStatus, otpError } =
    useGenerator(iboNumber, iboEmail);

  const cmsForm = useRef(null);

  const handleGenerateTempToken = async () => {
    setActiveOutput("tempToken");
    await generate();
  };

  const handleCMSLogin = async (loginUrl) => {
    setActiveOutput("tempToken");
    await generate();
    if (cmsForm.current) {
      cmsForm.current.action = loginUrl;
      cmsForm.current.submit();
    }
  };
  const handleGenerateOtp = async () => {
    setActiveOutput("otp");
    await generateOtp();
  };

  return (
    <div className={styles.container}>
      <TabActionBar>
        <Button
          disabled={status === STATUS_GENERATING}
          onClick={() => handleCMSLogin(cmsLoginUrl)}
        >
          CMS Login
        </Button>

        {cmsNewLoginUrl &&
          (window.location.hostname === "localhost" ||
            window.location.hostname.includes("dev")) && (
            <Button
              disabled={status === STATUS_GENERATING}
              onClick={() => handleCMSLogin(cmsNewLoginUrl)}
            >
              CMS Login (wwdb.dev)
            </Button>
          )}

        <Button
          disabled={status === STATUS_GENERATING}
          onClick={handleGenerateTempToken}
        >
          {status === STATUS_GENERATING ? "Generating..." : "Make Temp Token"}
        </Button>

        <Button
          disabled={otpStatus === STATUS_GENERATING}
          onClick={handleGenerateOtp}
        >
          {otpStatus === STATUS_GENERATING ? "Generating..." : "Generate OTP"}
        </Button>
      </TabActionBar>

      {activeOutput === "tempToken" &&
        (status === STATUS_GENERATING || password) && (
          <>
            <AlertNotice
              icon={<IconAlert />}
              title="Do not share tokens with IBOs."
            >
              Tokens are for QA and development use only.
            </AlertNotice>
            <div className={styles.passwordDisplay}>
              {status === STATUS_GENERATING ? (
                <p className={styles.generatingLabel}>Generating password...</p>
              ) : (
                password && (
                  <div className={styles.credentialsLayout}>
                    <CopyBox
                      label="Username"
                      value={iboNumber}
                      valueClassName={styles.copyValue}
                    />
                    <CopyBox
                      label="Password"
                      value={password}
                      autoCopy
                      valueClassName={styles.copyValue}
                    />
                  </div>
                )
              )}
            </div>
          </>
        )}

      {activeOutput === "otp" && (otpStatus === STATUS_GENERATING || otp) && (
        <div className={styles.passwordDisplay}>
          {otpStatus === STATUS_GENERATING ? (
            <p className={styles.generatingLabel}>Generating OTP...</p>
          ) : (
            otp && (
              <div className={styles.otpLayout}>
                <CopyBox
                  label="Email"
                  value={iboEmail}
                  autoCopy
                  valueClassName={styles.copyValue}
                />
                <CopyBox
                  label="OTP"
                  value={otp.code}
                  valueClassName={styles.copyValue}
                />
              </div>
            )
          )}
          {otpError && <div className={styles.errorDisplay}>{otpError}</div>}
        </div>
      )}

      <form
        ref={cmsForm}
        className={styles.cmsForm}
        method="post"
        target="_blank"
        action=""
      >
        <input id="user_login" name="log" type="hidden" value={iboNumber} />
        <input id="user_pass" name="pwd" type="hidden" value={password || ""} />
      </form>
    </div>
  );
};

export default Generate;
